import ArticleEntry from './ArticleEntry';

export default ArticleEntry;
